import { useGetPurchaseHistoryQuery } from '@/queries/useGetPurchaseHistoryQuery';
import { useEffect, useState } from 'react';

export const usePurchaseHistory = () => {
  const { data: purchaseData, isLoading } = useGetPurchaseHistoryQuery();
  const [showMore, setShowMore] = useState(false);
  // Прокрутка вверх при монтировании компонента (обновлении страницы)
  useEffect(() => {
    // Используем setTimeout для гарантии выполнения после рендера
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }, 500);
  }, []);

  useEffect(() => {
    if (!showMore) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [showMore]);

  if (isLoading) {
    return { purchaseData: [], isLoading };
  }

  return { purchaseData, showMore, setShowMore };
};
